<template>
  <div v-if="type==='line'" class="lee-progress"
       :style="'--h:'+strokeWidth+'px;--bgcolor:'+backgroundColor+';--atcolor:'+activeColor+';--bordius:'+borderRadius+'px;--percent:'+lastPercent+'%'">
    <div class="lee-progress-bar">
      <div class="lee-progress-inner-bar" :style="'width:'+b+'%'">
      </div>
    </div>
    <div class="lee-progress-info" v-if="showInfo">{{b}}%</div>
  </div>
  <div v-else class="lee-progress-circle">
    <canvas :width="radius*2+strokeWidth*2" :height="radius*2+strokeWidth*2" ref="canvas"></canvas>
  </div>
</template>
<script>
export default {
    name: 'LeeTProgress',
    data() {
        return {
            b: 0,
            st: null,
            lastPercent:0
        }
    },
    mounted() {
        if (!this.animate) {
            this.b = this.lastPercent
            if (this.type === 'circle') {
                this.drawStatic()//绘制静态的圆环
            }
        } else {
            this.dong()
        }

    },
    computed: {},
    methods: {
        dong() {
            this.b += 1
            if (this.type === 'circle') {
                this.drawFrame()
            }
            if (this.b >= this.lastPercent) {
                return
            }
            requestAnimationFrame(this.dong)
        },
        drawFrame() {
            let ctx = this.$refs.canvas.getContext("2d");
            ctx.clearRect(0, 0, this.radius * 2 + this.strokeWidth * 2, this.radius * 2 + this.strokeWidth * 2);
            this.backgroundCircle(ctx);
            this.text(ctx);
            this.foregroundCircle(ctx);
        },
        drawStatic() {
            let ctx = this.$refs.canvas.getContext("2d");
            this.backgroundCircle(ctx);
            this.text(ctx);
            this.foregroundCircle(ctx);
        },
        backgroundCircle(ctx) {
            ctx.lineWidth = this.strokeWidth
            ctx.strokeStyle = this.backgroundColor
            let cx = this.radius + this.strokeWidth
            let cy = this.radius + this.strokeWidth
            ctx.save()
            ctx.beginPath()
            ctx.arc(cx, cy, this.radius, 0, 2 * Math.PI)
            ctx.stroke()
            ctx.closePath()
            ctx.restore()
        },
        text(ctx) {
            let cx = this.radius + this.strokeWidth
            let cy = this.radius + this.strokeWidth
            ctx.fillStyle = this.activeColor;
            let font_size = this.radius / 2.2;
            ctx.font = font_size + "px Helvetica";
            ctx.save();
            let text_width = ctx.measureText(this.b.toFixed(0) + "%").width;
            ctx.fillText(this.b.toFixed(0) + "%", cx - text_width / 2, cy + font_size / 2);
            ctx.restore();
        },
        foregroundCircle(ctx) {
            let cx = this.radius + this.strokeWidth
            let cy = this.radius + this.strokeWidth
            let rad = Math.PI * 2 / 100;//每个百分比对应的弧度增加
            ctx.strokeStyle = this.activeColor
            ctx.lineCap = "round"
            ctx.save();
            ctx.beginPath()
            ctx.arc(cx, cy, this.radius, -Math.PI / 2, -Math.PI / 2 + rad * this.b)
            ctx.stroke()
            ctx.closePath()
            ctx.restore();
        },
    },
    watch: {
        percent: {
            immediate: true,
            handler(value) {
                this.lastPercent=value>100?100:value
            }
        }
    },
    props: {
        type: {
            type: String,
            default: 'line'
        },
        radius: {
            type: Number,
            default: 64
        },
        percent: {
            type: Number,
            default: 10
        },
        strokeWidth: {
            type: Number,
            default: 3
        },
        borderRadius: {
            type: Number,
            default: 0
        },
        activeColor: {
            type: String,
            default: '#09BB07'
        },
        backgroundColor: {
            type: String,
            default: '#EBEBEB'
        },
        showInfo: {
            type: Boolean,
            default: false
        },
        animate: {
            type: Boolean,
            default: false
        }
    }
};
</script>
<style>
.lee-progress {
  display: flex;
  align-items: center;
}

.lee-progress-bar {
  flex-grow: 1;
  height: var(--h);
  background-color: var(--bgcolor);
  overflow: hidden;
  border-radius: var(--bordius)
}

.lee-progress-inner-bar {
  height: var(--h);
  background-color: var(--atcolor);
}


.lee-progress-info {
  flex-shrink: 0;
  padding-left: 15px
}

</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeProgress.vue